module.exports = __webpack_public_path__ + "static/media/26130031-GOUzwSgs.eaa1b9b9.JPG";